<template>
    <div>
        <el-upload :action="uploadUrl" :headers="headers" list-type="picture-card" :auto-upload="true"
            :on-success="handleUploadSuccess" :on-remove="handleRemove" :file-list="fileList">
            <i slot="default" class="el-icon-plus"></i>
            <template v-slot:file="{ file }">
                <img class="el-upload-list__item-image" :src="baseUrl + file.imgUrl">
                <span class="el-upload-list__item-actions">
                    <span class="el-upload-list__item-preview" @click="handlePlay(file)">
                        <i class="el-icon-video-play"></i>
                    </span>
                    <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleRemove(file)">
                        <i class="el-icon-delete"></i>
                    </span>
                </span>
            </template>
        </el-upload>
         <media-preview ref="mediaPreview"></media-preview>
    </div>
</template>

<script>
import { getToken } from "@/utils/auth";

export default {
    props: {
        value: { String, require: true }
    },
    // 修改后
    watch: {
        value: {
            immediate: true, // 立即执行一次
            handler() {
                if (this.$utils.isValid(this.value)) {
                    const files = this.value.split(",")
                    files.forEach(el => {
                        if (el === '') return;
                        const index = this.fileList.findIndex(item => item.url === el);
                        if (index === -1) this.fileList.push({ url: el, imgUrl: el.replace(".mp4", ".jpg") })
                    });
                }
            },
            deep: true
        }
    },
    data() {
        return {
            baseUrl: process.env.VUE_APP_BASE_API,
            uploadUrl: process.env.VUE_APP_BASE_API + "/common/uploadVideo",
            headers: {
                Authorization: "Bearer " + getToken(),
            },
            fileList: [], // 上传文件列表
            dialogVisible: false,
            disabled: false,
            videoSrc: "", // 需要定义
        };
    },
    methods: {
        updateValue() {
            const files = this.fileList.map(el => el.url).join(",");
            this.$emit('input', files)
        },
        // 上传成功
        handleUploadSuccess(response, file, fileList) {
            const videoUrl = response.fileName;
            this.$set(file, "url", videoUrl);
            const imageUrl = videoUrl.replace(".mp4", ".jpg");
            this.$set(file, "imgUrl", imageUrl);
            this.fileList = [...fileList];
            this.updateValue();//更新value
            console.log("上传成功", file);
        },
        // 删除文件
        handleRemove(file) {
            const index = this.fileList.findIndex(el => el.url == file.url);
            this.fileList.splice(index, 1);
            this.updateValue();//更新value
        },

        // 播放视频
        handlePlay(file) {
            let index = this.fileList.findIndex(el => el.url === file.url);
            let files = this.fileList.map(el => this.baseUrl + el.url);
            this.$refs.mediaPreview.open(files, index);
        },
    },
};
</script>

<style>
.el-upload-list__item-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
}
</style>